import { render } from "./category-leaderboard-filter.vue?vue&type=template&id=ec08b626&scoped=true&ts=true"
import script from "./category-leaderboard-filter.vue?vue&type=script&lang=ts"
export * from "./category-leaderboard-filter.vue?vue&type=script&lang=ts"

import "./category-leaderboard-filter.vue?vue&type=style&index=0&id=ec08b626&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec08b626"]])

export default __exports__